var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-length",class:{ limit: _vm.count === _vm.max }},[_c('span',{class:{ 'text-danger': _vm.limit < 0 || (_vm.min && _vm.count < _vm.min) }},[_vm._v(" "+_vm._s(_vm.count))]),_vm._v(" / "+_vm._s(_vm.max)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }